import Swiper from "swiper";
import { A11y, Keyboard, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import { gsap } from "@gsap";

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

function createSwiper(panel) {
	return new Swiper(panel.querySelector(".swiper"), {
		modules: [A11y, Keyboard, Scrollbar],
		slidesPerView: 1.2,
		spaceBetween: 12,
		grabCursor: true,
		watchOverflow: true,
		keyboard: { enabled: true, onlyInViewport: true },
		scrollbar: { el: panel.querySelector(".product-explorer-scrollbar"), draggable: true },
		breakpoints: {
			768: { slidesPerView: 2.2, spaceBetween: 16 },
			992: { slidesPerView: 3, spaceBetween: 16 },
			1201: { slidesPerView: 4, spaceBetween: 16 },
		},
	});
}

function initTabs(layout, panels, swipers) {
	const tablist = layout.querySelector(".product-explorer-tabs");
	if (!tablist) return;

	const tabs = [...tablist.querySelectorAll(".product-explorer-tab")];
	let current = 0;

	const movePill = () => {
		const tab = tabs[current];
		tablist.style.setProperty("--pill-x", `${tab.offsetLeft}px`);
		tablist.style.setProperty("--pill-w", `${tab.offsetWidth}px`);
	};

	const select = (index, focus = false) => {
		if (index === current) return;
		current = index;

		tabs.forEach((tab, i) => {
			const active = i === index;
			tab.setAttribute("aria-selected", active ? "true" : "false");
			tab.tabIndex = active ? 0 : -1;
			panels[i].hidden = !active;
		});

		movePill();
		swipers[index].update();
		swipers[index].slideTo(0, 0);
		if (focus) tabs[index].focus();

		if (reducedMotion.matches) return;

		gsap.fromTo(
			panels[index].querySelectorAll(".swiper-slide"),
			{ autoAlpha: 0, y: 24 },
			{ autoAlpha: 1, y: 0, duration: 0.6, ease: "power3.out", stagger: 0.06, overwrite: true },
		);
	};

	tabs.forEach((tab, index) => tab.addEventListener("click", () => select(index)));

	tablist.addEventListener("keydown", (event) => {
		const keys = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: tabs.length - 1 };
		if (!(event.key in keys)) return;

		event.preventDefault();
		select((keys[event.key] + tabs.length) % tabs.length, true);
	});

	movePill();
	new ResizeObserver(movePill).observe(tablist);
	requestAnimationFrame(() => tablist.classList.add("has-pill"));
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".product_explorer-layout").forEach((layout) => {
		const panels = [...layout.querySelectorAll(".product-explorer-panel")];
		const swipers = panels.map(createSwiper);

		initTabs(layout, panels, swipers);
	});
});
